<template>
  <div class="px-4 sm:px-5 lg:px-5 mt-5 w-full ">
    <div class="text-right mb-5">
      <button @click="toggleAdd" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
        {{ $t('customers.add') }}
      </button>
    </div>
    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" colspan="2" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{$t("customers.name")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("customers.phone")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("customers.email")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("customers.conversation")}}</th>
            <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span class="sr-only">{{$t("automations.actions")}}</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="customer in this.customerStore.collection" :key="customer.id">
            <CustomerListItem v-if="customer.attributes" v-bind:customer="customer" v-bind:sourceMerge="sourceMerge" v-bind:targetMerge="targetMerge"
                          v-on:merge-target-selected-event="mergeTargetSelected"
                          v-on:merge-source-selected-event="mergeSourceSelected" />
          </tr>
        </tbody>
      </table>
      <div v-if="showMerge">
        <CustomersMerge v-bind:sourceMerge="sourceMerge" v-bind:targetMerge="targetMerge" v-on:merge-finished-event="clearMerge" />
      </div>
    </div>
  </div>
  <CustomerAdd v-if="showAdd" v-on:create-finished-event="createEnded" />
</template>

<script>
import CustomerListItem from './customers/CustomerListItem';
import CustomersMerge from './customers/CustomersMerge';
import CustomerAdd from './customers/CustomerAdd';

import { useCustomerStore } from '@/stores/customers';
import customerModel from '@/models/customer'


export default {
  name: 'CustomersPage',
  components: { CustomerListItem, CustomersMerge, CustomerAdd },
  setup() {
    let customerStore = useCustomerStore();
    return {
      customerStore,
    };
  },
  async created() {
    this.$root.messageEmit('closed_conversations_requested', this.$root.token);
    await this.fetchCustomers();
  },
  methods: {
    async fetchCustomers() {
      let response = await customerModel.getCustomers(this.axios, this.$root.token);
      response.data.data.forEach(customer => {
        this.customerStore.replaceOrAdd(customer);
      });
    },
    mergeSourceSelected(customer) {
      this.sourceMerge = customer;
    },
    mergeTargetSelected(customer) {
      this.targetMerge = customer;
    },
    setName(name) {
      this.targetMerge.name = name;
    },
    setPhone(phone) {
      this.targetMerge['phone-number'] = phone;
    },
    clearMerge() {
      this.sourceMerge = undefined;
      this.targetMerge = undefined;
    },
    toggleAdd() {
      this.showAdd = !this.showAdd;
    },
    createEnded() {
      this.toggleAdd();
      this.fetchCustomers();
    }
  },
  computed: {
    showMerge() {
      return this.sourceMerge && this.targetMerge;
    }
  },
  data() {
    return {
      sourceMerge: undefined,
      targetMerge: undefined,
      showAdd: false,
    }
  },
}
</script>
